var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Tooltip from "bootstrap-vue/es/directives/tooltip/tooltip";
var LoginButton = /** @class */ (function (_super) {
    __extends(LoginButton, _super);
    function LoginButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LoginButton.prototype, "title", {
        get: function () {
            return this.$props.captionFormat.replace(/\{0\}/g, this.$props.caption);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginButton.prototype, "text", {
        get: function () {
            return this.$props.textFormat.replace(/\{0\}/g, this.$props.caption);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true })
    ], LoginButton.prototype, "type", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], LoginButton.prototype, "caption", void 0);
    __decorate([
        Prop({ type: String, default: "Log in using your {0} account" })
    ], LoginButton.prototype, "captionFormat", void 0);
    __decorate([
        Prop({ type: String, default: "{0}" })
    ], LoginButton.prototype, "textFormat", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], LoginButton.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: String })
    ], LoginButton.prototype, "buttonClass", void 0);
    __decorate([
        Prop({ type: String })
    ], LoginButton.prototype, "icon", void 0);
    LoginButton = __decorate([
        Component({
            name: "Login",
            directives: {
                "b-tooltip": Tooltip
            }
        })
    ], LoginButton);
    return LoginButton;
}(Vue));
export default LoginButton;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/LoginButton.vue
// module id = 667
// module chunks = 24